module.exports = __webpack_public_path__ + "static/media/QuarantineMusicVideo.01ee4677.mov";